// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/frazurich.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div .alert-danger {
  background-color: #fd77a4;
}

.alert-danger .btn-close {
  opacity: 1 !important; /* Ensure full opacity */
  filter: invert(100%) !important; /* Ensure the icon is white */
}

.background-container {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed; 
  background-size: cover;
}
  
.btn-info.btn-simple {
  color: #0c4160;
}

.btn-info.btn-simple:hover,
.btn-info.btn-simple:focus,
.btn-info.btn-simple:active,
.btn-info.btn-simple.active {
  color: #ffffff;
  background-color: #3358f4;
  background-image: linear-gradient(to bottom left, #0c4160, #3358f4, #0c4160);
}




.alert.alert-warning {
    color: #07273a;
    background-color: #ced9df;
    border-color: #b6c6cf;
  }


  .selected-row {
    background-color: #f0f0f0; /* Light grey */
    cursor: pointer; /* Optional: Indicate row is clickable */
  }
  

.object-selector .dropdown-menu {
    overflow: scroll;
}




.flip-enter {
    transform: rotateY(90deg);
    opacity: 0;
}
.flip-enter-active {
    transform: rotateY(0deg);
    opacity: 1;
    transition: transform 0.6s ease-in-out, opacity 0.6s ease-in-out;
}
.flip-exit {
    transform: rotateY(0deg);
    opacity: 1;
}
.flip-exit-active {
    transform: rotateY(-90deg);
    opacity: 0;
    transition: transform 0.6s ease-in-out, opacity 0.6s ease-in-out;
}


.cornerLogo{
    height: 40px;
    margin-right: 10px;
}










button.button-frame {
    border: 1px solid var(--bs-chinese-silver);
    border-radius: 4px;
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  button.button-frame:hover {
    border: 1px solid var(--bs-lighter);
  }
  
  .arrow {
    font-size: 18px;
    transition: transform 0.3s ease-in-out;
  }
  
  .arrow-open {
    transform: rotate(0deg);
  }
  
  .arrow-closed {
    transform: rotate(180deg);
  }
  
  button.iconButton {
    border: 1px solid var(--bs-chinese-silver);
    display: inline-block;
    padding: 8px;
  }
  button.iconButton span {
    font-size: 24px;
}

div textarea.form-control {
  padding: 0.5rem 0.7rem;
}

.bigNodeIcon {
  font-size: 5rem;
  text-align: center;
  margin-bottom: -10px;
}
.bigNodeLabel {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 10px;
}

.card-min-height {
  min-height: 570px;
}




.sortable-text:hover {
    text-decoration: underline;
    color: var(--color-sf-primary);
}



.white-content .table-responsive .input-group {
    margin-top: 6px;
}

.white-content .table-responsive .input-group .btn-icon {
    margin-top: 4px;
}

.input-group .icon-only {
    margin-top: 2px;
}

.rights-table .input-group .form-control{
    margin-top: 0px!important;
}





`, "",{"version":3,"sources":["webpack://./src/assets/css/own.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB,EAAE,wBAAwB;EAC/C,+BAA+B,EAAE,6BAA6B;AAChE;;AAEA;EACE,iFAA+E;EAC/E,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,yBAAyB;EACzB,4EAA4E;AAC9E;;;;;AAKA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;;;EAGA;IACE,yBAAyB,EAAE,eAAe;IAC1C,eAAe,EAAE,wCAAwC;EAC3D;;;AAGF;IACI,gBAAgB;AACpB;;;;;AAKA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,UAAU;IACV,gEAAgE;AACpE;AACA;IACI,wBAAwB;IACxB,UAAU;AACd;AACA;IACI,0BAA0B;IAC1B,UAAU;IACV,gEAAgE;AACpE;;;AAGA;IACI,YAAY;IACZ,kBAAkB;AACtB;;;;;;;;;;;AAWA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;IAC1C,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,eAAe;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;;;;AAKA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;;;AAIA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["div .alert-danger {\n  background-color: #fd77a4;\n}\n\n.alert-danger .btn-close {\n  opacity: 1 !important; /* Ensure full opacity */\n  filter: invert(100%) !important; /* Ensure the icon is white */\n}\n\n.background-container {\n  background: url('../../assets/img/frazurich.jpg') no-repeat center center fixed; \n  background-size: cover;\n}\n  \n.btn-info.btn-simple {\n  color: #0c4160;\n}\n\n.btn-info.btn-simple:hover,\n.btn-info.btn-simple:focus,\n.btn-info.btn-simple:active,\n.btn-info.btn-simple.active {\n  color: #ffffff;\n  background-color: #3358f4;\n  background-image: linear-gradient(to bottom left, #0c4160, #3358f4, #0c4160);\n}\n\n\n\n\n.alert.alert-warning {\n    color: #07273a;\n    background-color: #ced9df;\n    border-color: #b6c6cf;\n  }\n\n\n  .selected-row {\n    background-color: #f0f0f0; /* Light grey */\n    cursor: pointer; /* Optional: Indicate row is clickable */\n  }\n  \n\n.object-selector .dropdown-menu {\n    overflow: scroll;\n}\n\n\n\n\n.flip-enter {\n    transform: rotateY(90deg);\n    opacity: 0;\n}\n.flip-enter-active {\n    transform: rotateY(0deg);\n    opacity: 1;\n    transition: transform 0.6s ease-in-out, opacity 0.6s ease-in-out;\n}\n.flip-exit {\n    transform: rotateY(0deg);\n    opacity: 1;\n}\n.flip-exit-active {\n    transform: rotateY(-90deg);\n    opacity: 0;\n    transition: transform 0.6s ease-in-out, opacity 0.6s ease-in-out;\n}\n\n\n.cornerLogo{\n    height: 40px;\n    margin-right: 10px;\n}\n\n\n\n\n\n\n\n\n\n\nbutton.button-frame {\n    border: 1px solid var(--bs-chinese-silver);\n    border-radius: 4px;\n    width: 100%;\n    padding: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  button.button-frame:hover {\n    border: 1px solid var(--bs-lighter);\n  }\n  \n  .arrow {\n    font-size: 18px;\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .arrow-open {\n    transform: rotate(0deg);\n  }\n  \n  .arrow-closed {\n    transform: rotate(180deg);\n  }\n  \n  button.iconButton {\n    border: 1px solid var(--bs-chinese-silver);\n    display: inline-block;\n    padding: 8px;\n  }\n  button.iconButton span {\n    font-size: 24px;\n}\n\ndiv textarea.form-control {\n  padding: 0.5rem 0.7rem;\n}\n\n.bigNodeIcon {\n  font-size: 5rem;\n  text-align: center;\n  margin-bottom: -10px;\n}\n.bigNodeLabel {\n  font-size: 2.5rem;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.card-min-height {\n  min-height: 570px;\n}\n\n\n\n\n.sortable-text:hover {\n    text-decoration: underline;\n    color: var(--color-sf-primary);\n}\n\n\n\n.white-content .table-responsive .input-group {\n    margin-top: 6px;\n}\n\n.white-content .table-responsive .input-group .btn-icon {\n    margin-top: 4px;\n}\n\n.input-group .icon-only {\n    margin-top: 2px;\n}\n\n.rights-table .input-group .form-control{\n    margin-top: 0px!important;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
